/**
 * Created by zxp on 2018/8/17.
 */
/**
 * 全局HTTP拦截
 * @param request
 * @param next
 */
// 安装完axios之后引入
import axios_ from 'axios'
import store from '../store/index'
import {ENTRY_URL} from '../config/index.js'

// const baseURL = (process.env.NODE_ENV !== 'production' ? '/api/' : 'http://139.199.170.181:1109/index.php/')

export const baseURL = process.env.API_URL

function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}
let axios = axios_.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

// -----------有关请求request的过滤器
axios.interceptors.request.use((request) => {
  let token = getUrlKey('token')
  if (!token || token === 'none') {
    token = localStorage.getItem('token') || ''
  }
  // let merchantId = getUrlKey('state')

  request.headers['token'] = token

  // -----------判断是否包含有接口的字符串，定制其他加载，把loading换成其他文字，dispatch作用相当于commit
  if (request.data && request.data.noOpenLoading) {
  } else {
    store.dispatch('openLoading')
  }
  return request
}, (error) => {
  console.log(error)
})
// -----------有关响应response的过滤器
axios.interceptors.response.use((response) => {
  // -----------关闭加载
  setTimeout(() => {
    store.dispatch('closeLoading')
  }, 100)
  // -----------根据后台返回的不同code做出对应处理
  switch (response.data.code) {
    case 200:
      // -----------返回正确信息，用resolve
      return Promise.resolve(response.data)
    case 9999:
      localStorage.clear()
      sessionStorage.clear()
      store.commit('clearUserState')
      // window.location.reload()

      // throw new Error('TOKEN_INVALID')
      // window.location.replace('/') // Redirect to the application entry point and clear history
      location.replace(ENTRY_URL)
      return Promise.reject(response.data)
    default:
      const isIgnoreError = response.config.isIgnoreError // 是否忽略错误
      if (isIgnoreError) {
        // 忽略错误就正常返回
        return Promise.resolve(response.data)
      } else {
        setTimeout(() => {
          store.dispatch('showToast', {msg: response.data.msg, time: 2000})
        }, 200)
        return Promise.reject(response.data)
      }
  }
}, (error) => {
  // -----------请求错误
  store.dispatch('closeLoading')
  if (JSON.stringify(error).indexOf('404') > 0) {
    store.dispatch('showToast', {msg: '系统出错', time: 3000})
  } else {
    store.dispatch('showToast', {msg: '网络出了点问题', time: 3000})
  }
  // -----------返回正确信息，用reject
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/http/index.js